import React from 'react';
import { Divider, ExternalLink, ExternalLinkContainer } from './MessageExternalLinks.styles';

const MessageExternalLinks = ({ ticket, isAdmin, isBraintrustEnabled, onBraintrustClick }) => {
  const observableAIInteractions = ticket.moreTicketInfo?.observableAiInteractions || {};

  const {
    ivrInteractionUrl: { interactionUrl: ivrInteractionURL = null } = {},
    expertInteractionUrl: { interactionUrl: expertInteractionURL = null } = {},
  } = observableAIInteractions;

  const links = [
    ivrInteractionURL && (
      <ExternalLink key="ivr" href={ivrInteractionURL} target="_blank" rel="noopener noreferrer">
        ObserveAI (IVR Bot)
      </ExternalLink>
    ),
    expertInteractionURL && (
      <ExternalLink key="expert" href={expertInteractionURL} target="_blank" rel="noopener noreferrer">
        ObserveAI (Expert)
      </ExternalLink>
    ),
    isAdmin && isBraintrustEnabled && (
      <ExternalLink key="braintrust" href="#" onClick={onBraintrustClick}>
        Braintrust
      </ExternalLink>
    ),
  ].filter(Boolean);

  if (links.length === 0) {
    return null;
  }

  return (
    <ExternalLinkContainer>
      {links.reduce((acc, link, i) => {
        if (i > 0) {
          acc.push(<Divider key={`divider-${i}`} />);
        }
        acc.push(link);

        return acc;
      }, [])}
    </ExternalLinkContainer>
  );
};

export default MessageExternalLinks;
